import { useEffect, useState } from 'react';
import { CHATBOT_URL } from '../config';

function RobotIcon({ size = 30 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="5" r="1.4" fill="currentColor" />
      <line x1="12" y1="6.4" x2="12" y2="8.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <rect x="4.5" y="8.4" width="15" height="12" rx="4" fill="currentColor" opacity="0.18" />
      <rect x="4.5" y="8.4" width="15" height="12" rx="4" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="9" cy="14.2" r="1.6" fill="currentColor" />
      <circle cx="15" cy="14.2" r="1.6" fill="currentColor" />
      <path d="M9 18h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="2.2" y1="13" x2="4.5" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="19.5" y1="13" x2="21.8" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export default function ChatbotWidget() {
  const [open, setOpen] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        setFullscreen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const close = () => {
    setOpen(false);
    setFullscreen(false);
  };

  return (
    <>
      <button
        className={`chatbot-bubble ${open ? 'chatbot-bubble-open' : ''}`}
        onClick={() => (open ? close() : setOpen(true))}
        title={open ? 'Fermer l\'assistant' : 'Ouvrir l\'assistant IA'}
        aria-label={open ? 'Fermer l\'assistant IA' : 'Ouvrir l\'assistant IA'}
        aria-expanded={open}
        aria-controls="chatbot-dialog"
      >
        {open ? <span className="chatbot-bubble-icon">✕</span> : <RobotIcon size={32} />}
        {!open && <span className="chatbot-bubble-ai-badge">IA</span>}
      </button>

      {open && (
        <>
          <button
            className="chatbot-backdrop"
            onClick={close}
            aria-label="Fermer depuis l'arrière-plan"
            tabIndex={-1}
          />
          <section
            id="chatbot-dialog"
            className={fullscreen ? 'chatbot-panel chatbot-panel-fullscreen' : 'chatbot-panel'}
            role="dialog"
            aria-modal="true"
            aria-label="Assistant IA MEA PULSE"
          >
            <div className="chatbot-panel-header">
              <span className="chatbot-panel-header-title">
                <RobotIcon size={20} /> Assistant IA
              </span>
              <div className="chatbot-panel-header-actions">
                <button
                  className="chatbot-panel-icon-btn"
                  onClick={() => setFullscreen((v) => !v)}
                  title={fullscreen ? 'Réduire' : 'Plein écran'}
                  aria-label={fullscreen ? 'Réduire le chatbot' : 'Afficher le chatbot en plein écran'}
                >
                  {fullscreen ? '🗗' : '⛶'}
                </button>
                <button
                  className="chatbot-panel-icon-btn"
                  onClick={close}
                  title="Fermer"
                  aria-label="Fermer le chatbot"
                >✕</button>
              </div>
            </div>
            <iframe src={CHATBOT_URL} title="Assistant IA MEA PULSE" className="chatbot-iframe" />
          </section>
        </>
      )}
    </>
  );
}
